import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, AlertController, Item  } from 'ionic-angular';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { GlobalProvider } from '../../providers/global/global';
import { SetPointPage } from '../set-point/set-point';
import { DatePipe } from '@angular/common';
import WebSocket from 'isomorphic-ws';



@IonicPage()
@Component({
  selector: 'page-detail',
  templateUrl: 'detail.html',
})
export class DetailPage {

  data: Observable<any>;
  data_tag: Observable<any>;
  lista: any;
  title: string;
  banco: string;
  tabela: string;
  ws: any;
  public loading;
 
  constructor(public navCtrl: NavController, public navParams: NavParams, public http: HttpClient, public global: GlobalProvider, public alerCtrl: AlertController, public datepipe: DatePipe
    ) {

    this.title = this.global.page_title;
  }





  createWebsocket(banco, tabela){
    try{
      
      //const WebSocket = require('isomorphic-ws')

      const ws = new WebSocket('ws://iot.digicomp.com.br:443');

      var self = this;

      ws.onopen = function open() {
        console.log('connected');
        let message = "{\"db\":\"" + banco + "\",\"tabela\":\"" + tabela + "\",\"ws\":1}";
        
        ws.send(message);
      };


      ws.onclose = function close() {
        console.log('disconnected');
      };

      
      ws.onmessage = function incoming(data) {
        //A função recebe os dados na variavel 'data', mas que na verdade é uma classe
        //Dentro da classe, os dados de interesse estão em uma variavel chamada 'data', string em formato json

        var message= JSON.parse(data.data);

        for(var i=0;i<self.lista.length;i++){

          if(self.lista[i].tag === message.tag){
            
            try{
              var card= self.lista[i];

              message.valor = Number.parseFloat(message.valor).toFixed(2);

              let comp = JSON.parse(card.complemento);

              if (comp.label != undefined && card.card_type == "digital")
              {
                if (message.valor == 1)
                {
                  message.valor = comp.label.split('/')[0];
                }
                else
                {
                  message.valor = comp.label.split('/')[1];
                }

                if (message.valor == "Automatico")
                {
                  message.valor = "Automático";
                }
              }
              if (comp.escala != undefined && (card.card_type == "analogico" || card.card_type == "comando_a"))
              {
                message.valor = message.valor * comp.escala;
                message.valor = Number.parseFloat(message.valor).toFixed(2);
              }
              else if (card.card_type == "multistate")
              {
                message.valor = comp[Number.parseInt(message.valor)];

                if (message.valor == "Automatico")
                {
                  message.valor = "Automático";
                }
              }

              card.valor= message.valor;
              
              message.timestamp = message.timestamp.replace(/-/g,'/');
              message.timestamp = message.timestamp.replace(/-/g,'/');
              message.timestamp = self.datepipe.transform(message.timestamp, 'dd/MM/yy HH:mm');
              card.timestamp= message.timestamp;

              break;
            }
            catch(e){
              console.error(e);
            }
          }
        }        
      };

      return ws;
    }
    catch(e){
      console.log(e);
    }
  }





  editSetPoint(card)
  {
    if (this.global.securityLevel < 4)
    {
      this.global.card_tag = card.tag;
      this.navCtrl.push(SetPointPage);
    }
  }





  selectItem(card)
  { /*
    this.timer = 0;
    this.preventSimpleClick = false;
    let delay = 200;

    this.timer = setTimeout(() => {
      if(!this.preventSimpleClick){
      
      console.log(card);

      document.getElementById("demo").innerHTML = card.tag;

      let confirm = this.alerCtrl.create({
        title: 'Reconhecer Alarme',
        message: 'Deseja reconhecer o alarme de '+ card.nome_tela + '?',
        buttons: [
          {
            text: 'Cancelar',
            handler: () => {
              console.log('Disagree clicked');
            }
          },
          {
            text: 'Confirmar',
            handler: () => {
              console.log('Agree clicked');
            }
          }
        ]
      });
      confirm.present()
   
    }, delay);
    */
  }
  




  ionViewDidEnter() {
    this.title = this.global.page_title;
    this.banco= this.global.banco;
    this.tabela= this.global.table;
    this.get_data();
    this.ws = this.createWebsocket(this.banco, this.tabela)
  }





  ionViewWillLeave(){
    this.ws.close(1000);
  }






  public get_data()
  {
    try{
      var url='http://iot.digicomp.com.br/api/public/ping/cards';
      this.global.check_jwt();
      let body=new FormData();
      body.append('db',this.global.banco);
      body.append('tabela',this.global.table);
      body.append('jwt',this.global.token);

      this.data=this.http.post(url,body);
      this.data.subscribe(data=>{
        
        for(let i=0; i<data.length; i++)
        {
          var value = Number.parseFloat(data[i].valor).toFixed(2);
          data[i].valor = value;

          let comp = JSON.parse(data[i].complemento);
          
          if (data[i].nome_tela == "Temperatura" || data[i].nome_tela == "Temperatura 1" || data[i].nome_tela == "Temperatura 2" || data[i].nome_tela == "Temperatura 3" || data[i].nome_tela == "Temperatura 4" || data[i].nome_tela == "Temperatura 5" || data[i].nome_tela == "Temperatura 6")
          {
            data[i].ue = "°C";
          }

          if (data[i].nome_tela == "Potencia")
          {
            data[i].nome_tela = "Potência";
          }

          if (data[i].nome_tela == "Frequencia")
          {
            data[i].nome_tela = "Frequência";
          }

          if (data[i].nome_tela == "Umidificacao")
          {
            data[i].nome_tela = "Umidificação";
          }

          if (data[i].nome_tela == "Ventilacao")
          {
            data[i].nome_tela = "Ventilação";
          }

          if (data[i].nome_tela == "Tensao Bateria")
          {
            data[i].nome_tela = "Tensão Bateria";
          }

          if (data[i].nome_tela == "Inundacao 1")
          {
            data[i].nome_tela = "Inundação 1";
          }

          if (data[i].nome_tela == "Inundacao 2")
          {
            data[i].nome_tela = "Inundação 2";
          }

          if (data[i].nome_tela == "Tensao A-B")
          {
            data[i].nome_tela = "Tensão A-B";
          }

          if (data[i].nome_tela == "Tensao B-C")
          {
            data[i].nome_tela = "Tensão B-C";
          }

          if (data[i].nome_tela == "Tensao C-A")
          {
            data[i].nome_tela = "Tensão C-A";
          }

          if (data[i].nome_tela == "Pressao Oleo")
          {
            data[i].nome_tela = "Pressão Óleo";
          }

          if (data[i].nome_tela == "Saida A")
          {
            data[i].nome_tela = "Saída A";
          }

          if (data[i].nome_tela == "Saida B")
          {
            data[i].nome_tela = "Saída B";
          }

          if (data[i].nome_tela == "Saida C")
          {
            data[i].nome_tela = "Saída C";
          }

          if (data[i].nome_tela == "Comando Partir")
          {
            data[i].nome_tela = "Partir";
          }

          if (data[i].nome_tela == "Comando Parar")
          {
            data[i].nome_tela = "Parar";
          }

          if (data[i].nome_tela == "Comando Carga")
          {
            data[i].nome_tela = "Carga";
          }

          if (data[i].nome_tela == "Comando Alivio")
          {
            data[i].nome_tela = "Alívio";
          }

          if (comp.label != undefined && data[i].card_type == "digital")
          {
            if (data[i].valor == 1)
            {
              data[i].valor = comp.label.split('/')[0];
            }
            else
            {
              data[i].valor = comp.label.split('/')[1];
            }

            if (data[i].valor == "Automatico")
           {
             data[i].valor = "Automático";
           }
          }
          else if (comp.escala != undefined && data[i].card_type == "analogico")
          {
            data[i].valor = data[i].valor * comp.escala;
            data[i].valor = Number.parseFloat(data[i].valor).toFixed(2);
          }
          else if (data[i].card_type == "multistate")
          {
            data[i].valor = comp[Number.parseInt(data[i].valor)];

            if (data[i].valor == "Automatico")
            {
             data[i].valor = "Automático";
            }
          }

          data[i].timestamp = data[i].timestamp.replace(/-/g,'/');
          data[i].timestamp = this.datepipe.transform(data[i].timestamp, 'dd/MM/yy HH:mm');
        }

        //console.log(data);

        this.lista = data;
      });
    }
    catch(e){
      console.error(e);
    }
  }

  writeRegisterSetPoint(card){
    console.log(card.card_type);
    if (this.global.securityLevel < 4 && (card.card_type == "comando_a" || card.card_type == "comando_d")){
      
      this.global.card_full= card;
      this.global.card_tag = card.tag;
      
      this.navCtrl.push('CommandPage', {
        //detailTipoCard: card.card_type = card.card_type
      });
    }
  }

  isCommandEnabled(card){
    try{
      if (this.global.securityLevel < 4 && (card.card_type == "comando_a" || card.card_type == "comando_d")){
        return true;
      }
      else{
        return false;
      }
    }catch(e){
      console.log(e);
    };
  }


  isDigitalCommand(card){
    try{
      if (card.card_type == "comando_d"){
        return true;
      }
      else{
        return false;
      }
    }catch(e){
      console.log(e);
    };
  }

}



// WEBPACK FOOTER //
// ./src/pages/detail/detail.ts